export const version = "hash/5.7.0";
//# sourceMappingURL=_version.js.map